import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import { getCalender } from '../../../../../api';
import moment from 'moment';
import './index.less';
import ActivityItem from './activity-item';
import Empty from '@/components/core-empty';

const prefixCls = 'yx-calendar-activity-list';
const ActivityList = React.forwardRef(({ startDate, endDate, rangeMode }, ref) => {
  const [activityList, setActivityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasLeftData, setHasLeftData] = useState(false);
  const [hasRightData, setHasRightData] = useState(false);
  const getActivityListData = () => {
    setLoading(true);
    const params = {
      startTime: startDate.format('YYYY-MM-DD HH:mm:ss'),
      endTime: endDate.format('YYYY-MM-DD HH:mm:ss'),
    };
    getCalender(params)
      .then((res = {}) => {
        // res.data = [
        //   //活动已开始且不报名5
        //   {
        //     planCode: 'HD202404102013018609',
        //     activityStatus: 1,
        //     activityBeginTime: 1711936800000, //0401
        //     activityEndTime: 1714788000000, //0502
        //     level: '12000',
        //     levelName: '平台大促S级',
        //     activityName: '2024年京东0410非买贵非锁价自动测试5主题活动',
        //     businessStartTime: 1710900000000, //2024-03-20 10:00:00
        //     businessEndTime: 1711764000000, //0330
        //     createTime: 1712751181000,
        //     version: 2,
        //   },
        //   //报名未开始,活动未开始1
        //   {
        //     planCode: 'HD202404102008568646',
        //     activityStatus: 1,
        //     activityBeginTime: 1714701600000, //0503
        //     activityEndTime: 1714788000000, //0502
        //     level: '12000',
        //     levelName: '事业部B级',
        //     activityName: '2024年京东0410非买贵非锁价自动测试4主题活动',
        //     businessStartTime: 1713110400000, //0501
        //     businessEndTime: 1714615200000, //0502
        //     createTime: 1712750937000,
        //     version: 2,
        //   },
        //   //报名开始,活动未开始2
        //   {
        //     planCode: 'HD202404102005144786',
        //     activityStatus: 1,
        //     activityBeginTime: 1714356000000, //0429
        //     activityEndTime: 1714701600000, //0503
        //     level: '12000',
        //     levelName: '事业部B级',
        //     activityName: '2024年京东0410买贵非锁价测试1主题活动',
        //     businessStartTime: 1713578400000, //0420
        //     businessEndTime: 1714010400000, //0425
        //     createTime: 1712750714000,
        //     version: 2,
        //   },
        //   //报名结束,活动未开始3
        //   {
        //     planCode: 'HD202404102001558969',
        //     activityStatus: 1,
        //     activityBeginTime: 1714701600000, //0503
        //     activityEndTime: 1714788000000, //0502
        //     level: '12000',
        //     levelName: '事业部B级',
        //     activityName: '2024年京东0410买贵锁价不建券测试1主题活动',
        //     businessStartTime: 1710900000000, //2024-03-20 10:00:00
        //     businessEndTime: 1711764000000, //0330
        //     createTime: 1712750515000,
        //     version: 2,
        //   },
        //   //活动以开始切可报名4
        //   {
        //     planCode: 'HD202404101959169417',
        //     activityStatus: 1,
        //     activityBeginTime: 1711936800000, //0401
        //     activityEndTime: 1714442400000, //0430
        //     level: '12000',
        //     levelName: '事业部B级',
        //     activityName: '2024年京东0410非买贵非锁价自动1主题活动',
        //     businessStartTime: 1713578400000, //0420
        //     businessEndTime: 1714010400000, //0425
        //     createTime: 1712750357000,
        //     version: 2,
        //   },
        //   //活动结束
        //   {
        //     planCode: 'HD202404101959169417',
        //     activityStatus: 1,
        //     activityBeginTime: 1710986400000, //0321
        //     activityEndTime: 1711159200000, //0323
        //     level: '12000',
        //     levelName: '事业部B级',
        //     activityName: '2024年主题活动',
        //     businessStartTime: 1708653600000, //0223
        //     businessEndTime: 1708740000000, //0224
        //     createTime: 1712750357000,
        //     version: 2,
        //   },
        // ];
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) {
          throw new Error(msg || '推荐活动接口请求失败');
        }
        if (Array.isArray(data)) {
          setActivityList(data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getClassNames = (item) => {
    let className = 'yx-calendar-full-line';
    const { activityEndTime, version, activityBeginTime, businessStartTime } = item;
    //活动结束时间在当前月份加1(当前4月 + 1 =》 5月1)之前,显示一半
    if (moment(activityEndTime) <= moment(startDate).add(1, 'M')) {
      className = 'yx-calendar-half-line half-line-float-left';
    }
    if (moment(version == 2 ? businessStartTime : activityBeginTime) >= moment(startDate).add(1, 'M')) {
      className = 'yx-calendar-half-line half-line-float-right';
    }
    return className;
  };

  useEffect(() => {
    getActivityListData();
  }, [startDate, endDate]);

  useEffect(() => {
    let hasLeft = false,
      hasRight = false;
    for (const item of activityList) {
      const className = getClassNames(item);
      if (className.indexOf('full') !== -1) {
        hasLeft = true;
        hasRight = true;
        break;
      }
      if (className.indexOf('left') !== -1) {
        hasLeft = true;
        continue;
      }
      if (className.indexOf('right') !== -1) {
        hasRight = true;
      }
    }
    activityList.map((item) => {
      const className = getClassNames(item);
      if (className.indexOf('full') !== -1) {
        hasLeft = true;
        hasRight = true;
      }
      if (className.indexOf('left') !== -1) {
        hasLeft = true;
      }
      if (className.indexOf('right') !== -1) {
        hasRight = true;
      }
    });
    if (activityList.length > 0 && !hasLeft && !hasRight) {
      hasLeft = true;
      hasRight = true;
    }
    setHasLeftData(hasLeft);
    setHasRightData(hasRight);
  }, [activityList]);
  const EmptyBox = ({ position }) => {
    return (
      <div className={`yx-calendar-activity-empty-${position}`}>
        <Empty
          className="empty-box"
          imageStyle={{
            height: 72,
          }}
          style={{ color: 'rgba(0,0,0,0.82)' }}
          description={<div>暂无大促活动</div>}
        />
        {/* <div className="empty-box">
          <img
            src="https://img13.360buyimg.com/img/jfs/t1/184937/21/40274/4379/6551df79Fe49e1a5d/46817c2a76820f6a.png"
            style={{
              width: 72,
            }}
          />
          <div>暂无大促活动</div>
        </div> */}
      </div>
    );
  };
  function gotoApplyPage(item) {
    log && log('yx_center', 'workbench_calendarclick', `{"activityid":"${item.planCode}"}`);
    window.open(`/activity-manage/merchants/detail?planCode=${item.planCode}`);
  }
  return (
    <>
      <div
        className="calendar-activity-list"
        style={{
          overflowY: 'auto',
          minHeight: hasLeftData && hasRightData ? 90 : 180,
          maxHeight: 200,
          position: 'relative',
          zIndex: 9,
        }}
      >
        <Spin spinning={loading}>
          <div className={`${prefixCls}`}>
            {activityList.map((item) => (
              <div
                key={item.planCode}
                className="yx-calendar-activity-item-container"
                onClick={() => gotoApplyPage(item)}
              >
                <div className={getClassNames(item)}>
                  <ActivityItem activityInfo={item} rangeMode={rangeMode} startDate={startDate} endDate={endDate} />
                </div>
              </div>
            ))}
          </div>
        </Spin>
      </div>
      {!hasLeftData && <EmptyBox position="left" />}
      {!hasRightData && <EmptyBox position="right" />}
    </>
  );
});

export default React.memo(ActivityList);
